import { postItem, patchItem, deleteItem } from "utils/ApiUtils";
import { Contractor } from 'classes';
import ODataUtil from './ODataUtil'


const contractors_endpoint = "/Contractor";
async function getProjectContractors(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = Contractor;
  const endpoint = contractors_endpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint });
  return data;
};


async function addContractor(projectId, data) {
  data = fieldMapping(data)
  data.projectId = projectId
  const resourcePath = `${contractors_endpoint}/Add`;
  const params = `?projectId=${projectId}`;
  const result = await postItem(resourcePath, params, data);
  return result;
};

async function updateContractor(contractorid, data) {
  // data = fieldMapping(data)
  const resourcePath = `${contractors_endpoint}/Update`;
  const params = `?contractorProjectId=${contractorid}`;
  const result = await patchItem(resourcePath, params, data);
  return result;
};

async function deleteContractor(projectId, contractor) {
  const resourcePath = `${contractors_endpoint}/Delete`;
  const params = `?id=${contractor.ContractorProjectId}`;
  const result = await deleteItem(resourcePath, params);
  return result;
};

const fieldMapping = (data) => {
  Object.keys(data).forEach((field) => {
    const updatedfield = field.split('_')[0]
    Contractor.columns.forEach(r => {
      if (r.type === 'date' && r.field.split('_')[0].toLowerCase() === updatedfield.toLowerCase() && data[field] !== null) {
        data[field] = new Date(data[field]).toISOString()
      }
    });
    if (updatedfield !== field) {
      data[updatedfield] = data[field]
      delete data[field]
    }
  })
  return data
}

export { getProjectContractors, addContractor, updateContractor, deleteContractor };